<template>
  <div class="info-page">
    <crumbs title="服务案例" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="100px"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>服务案例详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业名称" prop="companyName">
              <el-input
                v-model="form.companyName"
                placeholder="请输入企业名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="企业介绍" prop="companyDec">
              <el-input
                v-model="form.companyDec"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入企业介绍"
                maxlength="200"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="服务内容" prop="serviceName">
              <el-input
                v-model="form.serviceName"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入服务内容"
                maxlength="200"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="服务介绍" prop="serviceDec">
              <el-input
                v-model="form.serviceDec"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入服务介绍"
                maxlength="200"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="服务时间" prop="serviceDate">
              <el-date-picker
                v-model="form.serviceDate"
                type="date"
                placeholder="请选择服务时间"
                value-format="yyyy-MM-dd"
                prefix-icon="el-icon-date"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="图片" prop="imgUploadList">
              <image-upload
                url="/api/achievement/uploadachiattach"
                accept="image/jpeg,image/png,image/bmp,image/webp"
                :file-list.sync="form.imgUploadList"
                :num-limit="1"
                :size-limit="10"
                :multiple="false"
              >
                <template>
                  <el-alert
                    :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；图片建议比例为4：3；大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                    type="warning"
                  >
                  </el-alert>
                </template>
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceCaseInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        // 详细信息
        companyName: "",
        companyDec: "",
        serviceName: "",
        serviceDec: "",
        serviceDate: "",
        imgUploadList: [] // imgURL 相对应
      },
      rules: {
        companyName: [isEmpty("请输入企业名称")],
        companyDec: [isEmpty("请输入企业介绍")],
        serviceName: [isEmpty("请输入服务内容")],
        serviceDec: [isEmpty("请输入服务介绍")],
        serviceDate: [isEmpty("请选择服务时间", "change")],
        imgUploadList: [isEmpty("请上传图片", "change")]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        // list
        imgUploadList,
        ...others
      } = this.form;
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0].url : file.url || "";
      };
      const imgURL = deconstruct(imgUploadList[0]);
      // 处理字符串 转为数字
      const turnNumber = {};
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        imgURL
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // -1 => ""
        // list
        imgURL,
        ...others
      } = data;
      // 处理文件
      const turnFile = {
        imgUploadList: imgURL
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] =
          file === ""
            ? []
            : [
                {
                  url: file
                }
              ];
      });
      // 处理数字 转为字符串
      const turnNumber = {};
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        ...turnFile
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("service", "addCase", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("service", "addCase", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("service", "getCaseInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          // this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/serviceManage/serviceCaseList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
